const Fourohfour = () => {

    return <div className="container mb-20 text-neutral-600 p-5 sm:py-10 ">
        <h1 className="text-9xl font-bold pb-10 text-brand-green">404</h1>
        <h1 className="text-6xl font-bold pb-10">Page not found</h1>
        <p className="text-3xl sm:w-3/4">The page you are looking for may have been removed, had its name changed, or is temporarily unavailable.</p>
    </div>
}

export default Fourohfour;